/** UI shape for per-brand member settings (mapped from API v2BrandSettings). */
export type MemberBrandSettingUi = {
  brandId: string;
  name?: string | null;
  wantEmailNotifications: boolean;
  showCampaigns: boolean;
};

export function mapBrandSettingsFromApi(raw: unknown): MemberBrandSettingUi[] | undefined {
  if (!Array.isArray(raw) || raw.length === 0) {
    return undefined;
  }
  const out: MemberBrandSettingUi[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') {
      continue;
    }
    const r = item as Record<string, unknown>;
    const brandId = typeof r.brand_id === 'string' ? r.brand_id : '';
    if (!brandId) {
      continue;
    }
    out.push({
      brandId,
      name: typeof r.name === 'string' ? r.name : r.name === null ? null : undefined,
      wantEmailNotifications: Boolean(r.want_email_notifications),
      showCampaigns: Boolean(r.show_campaigns),
    });
  }
  return out.length ? out : undefined;
}
